export default __webpack_public_path__ + "static/media/03.f01556fb.jpg";